import { render, staticRenderFns } from "./candidate-search-component.vue?vue&type=template&id=0bc6fe53&scoped=true"
import script from "./candidate-search-component.ts?vue&type=script&lang=ts&external"
export * from "./candidate-search-component.ts?vue&type=script&lang=ts&external"
import style0 from "./candidate-search-component.scss?vue&type=style&index=0&id=0bc6fe53&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc6fe53",
  null
  
)

export default component.exports